export default "__VITE_ASSET__DJiJcrdV__"